export default __webpack_public_path__ + "static/media/GIF.7a84dfcc.gif";